import { APIOrderFieldDefinitionModel } from "../types/api";

export const filterFieldsByCompanyId = (orderFieldsDefinitions: APIOrderFieldDefinitionModel[] | null | undefined, companyId: string | undefined) => {
  return orderFieldsDefinitions?.filter(
    field =>
      !field.companies ||
      field.companies.length === 0 ||
      field.companies?.map(company => company.id).includes(companyId || ''),
  );
}